function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "import_svg__a",
  opacity: 1,
  fillRule: "evenodd",
  d: "M3.5 7h10.75L18 14H0l3.5-7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "import_svg__b",
  opacity: 1,
  fillRule: "evenodd",
  d: "M1.531 13L0 16h18l-1.64-3H1.53z"
}), /*#__PURE__*/React.createElement("path", {
  id: "import_svg__c",
  opacity: 1,
  fillRule: "evenodd",
  d: "M1.531 15L0 18h18l-1.64-3H1.53z"
}), /*#__PURE__*/React.createElement("path", {
  id: "import_svg__g",
  opacity: 1,
  d: "M8.5 0h1v11h-1z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "import_svg__d",
  maskUnits: "userSpaceOnUse",
  maskContentUnits: "userSpaceOnUse",
  x: 0,
  y: 0
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h18v18H0z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#import_svg__a",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("mask", {
  id: "import_svg__e",
  maskUnits: "userSpaceOnUse",
  maskContentUnits: "userSpaceOnUse",
  x: 0,
  y: 0
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h18v18H0z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#import_svg__b",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("mask", {
  id: "import_svg__f",
  maskUnits: "userSpaceOnUse",
  maskContentUnits: "userSpaceOnUse",
  x: 0,
  y: 0
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h18v18H0z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#import_svg__c",
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#import_svg__a",
  fillOpacity: 0,
  stroke: "#8395B7",
  strokeWidth: 2,
  mask: "url(#import_svg__d)"
});

var _ref4 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#import_svg__b",
  fillOpacity: 0,
  stroke: "#8395B7",
  strokeWidth: 2,
  mask: "url(#import_svg__e)"
});

var _ref5 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#import_svg__c",
  fillOpacity: 0,
  stroke: "#8395B7",
  strokeWidth: 2,
  mask: "url(#import_svg__f)"
});

var _ref6 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#import_svg__g",
  fill: "#8395B7"
});

function SvgImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.56143f44.svg";
export { ForwardRef as ReactComponent };